/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GenderEnum } from './genderEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskPatient { 
    readonly id: number;
    patientId: string;
    firstName?: string;
    lastName?: string;
    gender: GenderEnum;
}
export namespace TaskPatient {
}

export const TaskPatient_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskPatient_patientId_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(7),];

export const TaskPatient_firstName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const TaskPatient_lastName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const TaskPatient_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];


